import { Spinner as CircularProgress } from '../styleguide/icons/Spinner'
import React from 'react'
import { Suspense } from 'react'
import { ChildrenProps } from '../utils/utilityTypes'

export const WaitRemote = ({ children }: ChildrenProps) => {
	return <Suspense fallback={<CircularProgress />}>{children}</Suspense>
}
